export const styles = {
  fieldWrapper: 'relative flex flex-col gap-2',
  hint: 'absolute left-0 right-0 top-full z-10 mt-2 flex items-start justify-between gap-3 rounded-md bg-black px-4 py-3 text-sm text-white shadow-lg',
  hintClose: 'flex shrink-0 items-center text-white cursor-pointer',
} as const

export const texts = {
  amountInvalid: 'Valor no válido',
  lastFourPlaceholder: 'Los 4 últimos dígitos de la cuenta pagadora (opcional)',
  lastFourInvalid: 'Ingrese exactamente 4 dígitos',
  lastFourHint:
    'El ingreso de los últimos 4 dígitos de la cuenta bancaria es obligatorio para realizar pagos a través de BAC e Interbanco.',
  closeHint: 'Cerrar',
} as const
